import {
  APICallParams, APIInterfaceI, buildRequest, PaginationT,
} from '.';

class search implements APIInterfaceI {
  getAll = (pagination: PaginationT, params?: APICallParams) => (
    buildRequest('GET', `/search?cursor=${pagination.cursor}&limit=${pagination.limit}&search=${params?.search}`)
  );

  // eslint-disable-next-line no-unused-vars
  getOne = (targetId: string) => new Promise<any>((resolve) => { resolve(null); });

  // eslint-disable-next-line no-unused-vars
  register = (formData: any) => new Promise<any>((resolve) => { resolve(null); });

  // eslint-disable-next-line no-unused-vars
  delete = (targetId: string) => new Promise<any>((resolve) => { resolve(null); });

  // eslint-disable-next-line no-unused-vars
  update = (targetId: string, data: any) => new Promise<any>((resolve) => { resolve(null); });
}

export default search;
